import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Global scroll reset on route change.
 *
 * - Link click / navigate (PUSH, REPLACE) → jump to top instantly, before paint,
 *   so the new page never opens scrolled down at the footer.
 *   Also runs when only the query string changes (e.g. ?page=2 pagination).
 * - Back/forward (POP) → if the page saved a position via useScrollRestoration,
 *   leave it alone (the hook restores it after data loads); otherwise go to top.
 *
 * NOTE: Bootstrap sets `:root { scroll-behavior: smooth }`. A smooth scroll gets
 * cancelled when the new page swaps in (height changes), leaving the page stuck
 * near the footer. So we always force behavior: 'instant'.
 */
export const scrollTopInstant = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
};

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
}

const ScrollToTop = () => {
    const { pathname, search } = useLocation();
    const navType = useNavigationType();

    useLayoutEffect(() => {
        if (navType === "POP") {
            let saved = null;
            try {
                saved = sessionStorage.getItem(`scroll-pos:${pathname}`);
            } catch (e) { /* storage blocked */ }
            if (saved !== null) return;
        }
        scrollTopInstant();
    }, [pathname, search, navType]);

    return null;
};

export default ScrollToTop;
